import { render, staticRenderFns } from "./TestimonialsSlider.vue?vue&type=template&id=3b620804"
import script from "./TestimonialsSlider.vue?vue&type=script&lang=js"
export * from "./TestimonialsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports